import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import LoanRefusalCasePage from '@/pages/offers/page';
import LoyaltyPage from "@/pages/loyalty/page.tsx";
import CardsCasePage from "@/pages/cards/page.tsx";

const HomePage = lazy(() => import('../pages/home/page'));
const ApiMethodPage = lazy(() => import('../pages/api-method/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const OfferPage = lazy(() => import('../pages/offer/page'));
const AgreementPage = lazy(() => import('../pages/agreement/page'));
const LegalityPage = lazy(() => import('../pages/legality/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/offer',
    element: <OfferPage />,
  },
  {
    path: '/agreement',
    element: <AgreementPage />,
  },
  {
    path: '/legality',
    element: <LegalityPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/offers',
    element: <LoanRefusalCasePage />,
  },
  {
    path: '/apilist/*',
    element: <ApiMethodPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/loyalty',
    element: <LoyaltyPage />,
  },
  {
    path: '/cards',
    element: <CardsCasePage />,
  }
];

export default routes;
